import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { callValidateUser } from "http/auth/login";
import { useNavigate } from "react-router-dom";
import CryptoJS from "crypto-js";
import { ScaleLoader } from 'react-spinners';
import { callResendOTP } from 'http/auth/signup';
const LoadingPage = () => {
    const [isLoading, setIsLoading] = useState(true);
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const base64Param = searchParams.get('tk');
    const decodedParam = base64Param ? atob(base64Param) : null;
    const navigate = useNavigate();

    useEffect(() => {
        if (decodedParam) {
            fetchData();
        }
    }, [decodedParam]);

    const fetchData = async () => {
        callValidateUser({ token: decodedParam })
            .then((result) => {
                if (result.code == 200 && result.status) {
                    const { data, tokens, permissions } = result;
                    if (data.entityIsVerify == 1) {
                        data.EntityAssignedFlag = data.EntityAssignedFlag == 1
                        const passphrase = process.env.REACT_APP_KEY;
                        const encryptedUser = CryptoJS.AES.encrypt(
                            JSON.stringify(data),
                            passphrase
                        ).toString();

                        localStorage.setItem("user", encryptedUser)
                        localStorage.setItem("tokens", JSON.stringify(tokens));
                        localStorage.setItem("permissions", JSON.stringify(permissions));

                        const encryptedId = btoa(result.data.entityId.toString());

                        if (data.roleName === "fundLync_cutomer") {
                            localStorage.setItem("encryptedId", JSON.stringify(encryptedId));
                            navigate(
                                `/customer/entity-dashboard?id=${encodeURIComponent(
                                    encryptedId
                                )}`
                            );
                        } else if (data.roleName == "financier_admin") {
                            navigate(`/financier_admin/dashboard`);
                        } else if (data.roleName == "financier_operations") {
                            navigate(`/financier_operations/dashboard`);
                        } else {
                            navigate(`/${data.roleName}/dashboard`);
                        }
                    } else {
                        const postParams = {
                            entityId: String(data.entityId),
                            email: data.email,
                        };
                        callResendOTP(postParams)
                            .then((result) => {
                                if (result.status) {
                                    navigate({
                                        pathname: "/customer/register-otp-verify",
                                        search: `?email=${data.email}&entity=${data.entityId}`,
                                    });
                                    validationEmail.setSubmitting(false);
                                } else {
                                    const { message } = result;
                                    setToastInfo({ message: message, showToast: true, role: "error" });
                                }
                            })
                            .catch((e) => { })
                            .finally((f) => { });
                    }
                } else {
                    navigate('/login')
                }
            })
            .catch((e) => {
                setIsLoading(false)
            }).finally(() => {
                setIsLoading(false)
            })
    };

    return (
        <div>
            <div className='d-flex flex-column justify-content-center align-items-center h-100vh'>
                <ScaleLoader color={'#21aa47'} size={200} loading={isLoading} />
                <p>Validating...</p>
            </div>

        </div>
    );
};

export default LoadingPage;
